import { GET_POPUP } from "../graphql/queries/popup";
import { useQuery } from "@apollo/client";

export const usePopup = () => {
  const { loading, error, data } = useQuery(GET_POPUP);
  return {
    loading,
    data,
    error,
  };
};
